import styled from 'styled-components';

import { Breakpoint, Color, FontWeight, NewsBoxType } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Markdown } from '../markdown/markdown.component';

import { ContainerProps, DetailsProps, ImageItemProps } from './newsBox.types';

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  display: flex;
  flex-direction: ${({ $type }: ContainerProps): string => $type === NewsBoxType.Horizontal ? 'row' : 'column'};
  justify-content: space-between;
`;

export const Details: StyledComponent<'div', DetailsProps> = styled.div<DetailsProps>`
  width: ${({ $type }: DetailsProps): string => $type === NewsBoxType.Horizontal ? '40%' : '100%'};
`;

export const Header: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${Color.Black};
`;

export const Title: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  font-weight: ${FontWeight.Light};
  font-size: 18px;
  line-height: 22px;
  color: ${Color.Black};
  margin: 12px 0 24px;
  text-align: left;
`;

export const Description: StyledComponent<typeof Markdown> = styled(Markdown)`
  font-weight: ${FontWeight.Light};
  font-size: 14px;
  line-height: 20px;
  color: ${Color.Black};
  text-align: left;
`;

export const ImageItem: StyledComponent<'button', ImageItemProps> = styled.button.attrs<ImageItemProps>({ type: 'button' })`
  max-width: 396px;
  height: 510px;
  background: url(${({ $background }: ImageItemProps): string => $background});
  margin: ${({ $type }: ContainerProps): string => $type === NewsBoxType.Horizontal ? '0 0 0 24px' : '32px 0 0'};
  width: ${({ $type }: ContainerProps): string => $type === NewsBoxType.Horizontal ? '60%' : '100%'};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  @media ${Breakpoint.Tablet} {
    height: 268px;
  }

  @media ${Breakpoint.Mobile} {
    height: 444px;
  }

  @media ${Breakpoint.SmallMobile} {
    max-width: none;
  }
`;
